function BikeQuoteResultModel(quoteResultResponse) {
	this.isCoverAvailable = quoteResultResponse.quoteResult.totalPremium !== undefined ;
	this.coverType = quoteResultResponse.motorcycles[0].coverType;
	this.sumInsuredAmount = quoteResultResponse.motorcycles[0].sumInsuredAmount;
	this.quoteResult = quoteResultResponse.quoteResult;
	this.paymentPlan = quoteResultResponse.paymentPlan;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.totalFSL = quoteResultResponse.quoteResult.totalFSL ;
	this.totalGST = quoteResultResponse.quoteResult.totalGST ;
	this.totalStampDuty = quoteResultResponse.quoteResult.totalStampDuty ;
	this.premiumAfterDiscount = quoteResultResponse.quoteResult.premiumAfterDiscount ;
	this.totalPremium = quoteResultResponse.quoteResult.totalPremium ;
	this.paymentFrequency = quoteResultResponse.paymentPlan ? quoteResultResponse.paymentPlan.paymentFrequency : null ;
	this.excess = quoteResultResponse.motorcycles[0].excess ;
	this.availableSumInsuredTypes = quoteResultResponse.motorcycles[0].availableSumInsuredTypes;
	this.motorcycleValue = {
		upper: quoteResultResponse.motorcycles[0].agreedValueUpper,
		lower: quoteResultResponse.motorcycles[0].agreedValueLower
	};
	this.coverageOptions = quoteResultResponse.motorcycles[0].coverageOptions;
	this.response = quoteResultResponse ;

}
